<template>
  <li>
    <h2>{{ name }} {{ isTop ? '(Best Friend)' : '' }}</h2>
    <button @click="toggleTop">Toggle Best Friend</button>
    <button @click="toggleDetails">
      {{ detailsAreVisible ? 'Hide' : 'Show' }} Details
    </button>
    <ul v-if="detailsAreVisible">
      <li>Phone: {{ phoneNumber }}</li>
      <li>Email: {{ emailAddress }}</li>
    </ul>
    <button @click="$emit('delete', id)">Delete</button>
  </li>
</template>
<script>
export default {
  //   props: ["name", "phoneNumber", "emailAddress", "isTop"],
  props: {
    id: { type: String, required: true },
    name: { type: String, required: true },
    phoneNumber: { type: String, required: true },
    emailAddress: { type: String, required: true },
    isTop: {
      type: Boolean,
      required: false,
      default: false,
      //   validator: function(value) {
      //     return value === "1" || value === "0";
      //   },
    },
  },
  emits: ['toggle-top', 'delete'],
  //   emits: {
  //     "toggle-top": function(id) {
  //       if (id) {
  //         return true;
  //       } else {
  //         console.warn("Id missing");
  //         return false;
  //       }
  //     },
  //   },

  data() {
    return {
      detailsAreVisible: false,
    };
  },
  methods: {
    toggleDetails() {
      this.detailsAreVisible = !this.detailsAreVisible;
    },
    toggleTop() {
      this.$emit('toggle-top', this.id);
    },
  },
};
</script>
